// Pure lookups over GET v2/distributions (new_season_data.distributions):
// [{id, name, farming_units: [{id, name, country, region, salesforce_id, settings, role}]}].
// The New Season pages read distributions / farming units ONLY from here,
// never from the V1 store (distribution_data).

const findV2Distribution = (distributions, distributionId) =>
  (distributions || []).find(
    (distribution) => distribution.id === distributionId,
  ) || null;

const findV2FarmingUnit = (distributions, distributionId, farmingUnitId) =>
  (findV2Distribution(distributions, distributionId)?.farming_units || []).find(
    (farmingUnit) => farmingUnit.id === farmingUnitId,
  ) || null;

const farmingUnitIdsOf = (distributions, distributionId) =>
  (findV2Distribution(distributions, distributionId)?.farming_units || []).map(
    (farmingUnit) => farmingUnit.id,
  );

// "<country>/<name> <salesforce_id>"
const farmingUnitTitle = (farmingUnit) =>
  farmingUnit
    ? `${farmingUnit.country || ''}/${farmingUnit.name || ''} ${farmingUnit.salesforce_id || ''}`.trim()
    : '';

const sortByName = (items) =>
  (items || [])
    .slice()
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));

module.exports = {
  findV2Distribution,
  findV2FarmingUnit,
  farmingUnitIdsOf,
  farmingUnitTitle,
  sortByName,
};
